import { instance } from '../helpers'
import { REST_API_END_POINTS } from './constants'
import {AxiosInstance, AxiosResponse} from "axios";
import {GetApiResponse} from "./types";
export class GSXService {
  public instance: AxiosInstance;
  public url: string;

  constructor() {
    this.url = REST_API_END_POINTS.GSX
    this.instance = instance
  }

  warranty(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/warranty`, data)
  }

  logs(data):Promise<AxiosResponse> {
    console.log(data)
    return this.instance.get(`${this.url}/logs/`, { params: data })
  }

  diagnostic_suites(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/diagnostic_suites`, data)
  }

  run_diagnosis_suite(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/run_diagnosis_suite`, data)
  }

  diagnostics_lookup(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/diagnostics_lookup`, data)
  }
  diagnostics_customer_report_url(data):Promise<AxiosResponse> {
    return this.instance.post(
      `${this.url}/diagnostics_customer_report_url`,
      data
    )
  }

  diagnostics_status(data) {
    return this.instance.post(`${this.url}/diagnostics_status`, data)
  }
  repair_questions(data) {
    return this.instance.post(`${this.url}/repair_questions`, data)
  }

  repair_eligibility(data) {
    return this.instance.post(`${this.url}/repair_eligibility`, data)
  }

  repair_create(data) {
    return this.instance.post(`${this.url}/repair_create`, data)
  }

  repair_draft(data) {
    return this.instance.post(`${this.url}/repair_draft`, data)
  }

  repair_summary(data:any):Promise<AxiosResponse<GetApiResponse>> {
    return this.instance.post(`${this.url}/repair_summary`, data)
  }

  repair_details(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/repair_details`, data)
  }
  repair_audit(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/repair_audit`, data)
  }
  part_summary(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/part_summary`, data)
  }
  content_article_lookup(data):Promise<AxiosResponse> {
    console.log(data)
    return this.instance.post(`${this.url}/content_article_lookup`, data)
  }
  content_article(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/content_article`, data)
  }
  content_article_acknowledge(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/content_article_acknowledge`, data)
  }

  consignment_order_lookup(data):Promise<AxiosResponse> {
    return this.instance.post(`${this.url}/consignment_order_lookup`, data)
  }
  consignment_delivery_lookup(data) {
    return this.instance.post(`${this.url}/consignment_delivery_lookup`, data)
  }
  acknowledge_delivery(data) {
    return this.instance.post(`${this.url}/acknowledge_delivery`, {
      data: data,
    })
  }
  order_applecare_eligibility(data) {
    return this.instance.post(`${this.url}/order_applecare_eligibility`, {
      data: data,
    })
  }
  order_applecare_quote(data) {
    return this.instance.post(`${this.url}/order_applecare_quote`, {
      data: data,
    })
  }
  order_applecare_create(data) {
    return this.instance.post(`${this.url}/order_applecare_create`, {
      data: data,
    })
  }
  order_applecare_summary(data) {
    return this.instance.post(`${this.url}/order_applecare_summary`, {
      ...data,
    })
  }
  send_log_via_email(data) {
    return this.instance.post(`${this.url}/send_log_via_email`, data)
  }
  attachment_upload_access(data) {
    return this.instance.post(`${this.url}/attachment_upload_access`, data)
  }

  repair_product_componentissue(data) {
    return this.instance.post(`${this.url}/repair_product_componentissue`, data)
  }

   fetch_reservation_details(data) {
    return this.instance.post(`${this.url}/fetch_reservation_details`, data)
  }
}
